export const getNameFromListByType = (list, type, keys = {type: "memberType", fn: "firstName", ln: "lastName"}) => {
    const members = list.filter(member => member[keys.type] === type);

    if(members.length > 0) {
        return members.map(member => `${member.user[keys.fn]} ${member.user[keys.ln]}`).join(", ");
    }

    return "None";
}

export const getNameFromObject = (details, keys = {fn: "firstName", ln: "lastName"}) => {
    return `${details[keys.fn]} ${details[keys.ln]}`;
}